const mapStyles = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#525A6C"
            },
            {
                "lightness": 85
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#525A6C"
            },
            {
                "lightness": 85
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [

            {
                "color": "#0E2D6D"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#0E2D6D"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#0E2D6D"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
];

const markerIcon = {
    url: '/images/google-maps-marker.png',
    scaledSize: null,
};

const markerIcon247 = {
    url: '/images/google-maps-marker-247.png',
    scaledSize: null,
};

function loadMapsApi(mapsKey, locale, libraries) {
    if (window._mapsLoaded) {
        return Promise.resolve();
    }

    if (window._mapsLoading) {
        return window._mapsLoading;
    }

    window._mapsLoading = new Promise((resolve) => {
        if (typeof google !== 'undefined' && google.maps) {
            window._mapsLoaded = true;
            resolve();
            return;
        }

        const libs = libraries ? `&libraries=${libraries}` : '';
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${mapsKey}&language=${locale}${libs}`;
        script.onload = () => {
            window._mapsLoaded = true;
            resolve();
        };
        document.head.appendChild(script);
    });

    return window._mapsLoading;
}

function initMarkerIcons() {
    if (!markerIcon.scaledSize) {
        markerIcon.scaledSize = new google.maps.Size(26, 32);
        markerIcon247.scaledSize = new google.maps.Size(26, 32);
    }
}

export function placesOverview(config) {
    return {
        places: config.places || [],
        sortedPlaces: [],
        mapsKey: config.mapsKey || '',
        locale: config.locale || 'nl',
        mapReady: false,

        init() {
            this.sortedPlaces = [...this.places];
            loadMapsApi(this.mapsKey, this.locale, 'places').then(() => this.initMap());
        },

        initMap() {
            const mapElement = this.$refs.map;
            if (!mapElement) return;

            initMarkerIcons();

            const latlng = new google.maps.LatLng(50.861444, 4.284486);

            const map = new google.maps.Map(mapElement, {
                zoom: 8,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles,
                scrollwheel: false,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            });

            this._map = map;

            const bounds = new google.maps.LatLngBounds();

            this.places.forEach((place) => {
                if (!place.lat || !place.lng) return;

                const position = new google.maps.LatLng(place.lat, place.lng);

                const marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: place.has247 ? markerIcon247 : markerIcon,
                });

                marker.addListener('click', () => {
                    window.location.href = place.url;
                });

                bounds.extend(position);
            });

            if (this.places.length > 0) {
                map.fitBounds(bounds);
            }

            this.initAutocomplete(map);

            let boundsTimer = null;
            map.addListener('bounds_changed', () => {
                clearTimeout(boundsTimer);
                boundsTimer = setTimeout(() => this.sortByDistance(), 200);
            });

            this.mapReady = true;
        },

        initAutocomplete(map) {
            const searchInput = this.$refs.searchInput;
            if (!searchInput) return;

            const autocomplete = new google.maps.places.Autocomplete(searchInput, {
                types: ['(regions)'],
                componentRestrictions: { country: 'be' },
            });

            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (place.geometry) {
                    this.zoomToIncludeNearest(place.geometry.location);
                }
            });

            searchInput.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter') return;
                event.preventDefault();

                const pacSelected = document.querySelector('.pac-container .pac-item.pac-selected');
                const pacFirst = document.querySelector('.pac-container .pac-item:first-child');
                const suggestion = pacSelected || pacFirst;

                if (suggestion) {
                    const text = suggestion.textContent;
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ address: text }, (results, status) => {
                        if (status === 'OK' && results.length > 0) {
                            const loc = results[0].geometry.location;
                            searchInput.value = results[0].address_components[0].long_name;
                            this.zoomToIncludeNearest(loc);
                        }
                    });
                }
            });
        },

        zoomToIncludeNearest(location) {
            const lat = location.lat();
            const lng = location.lng();

            let nearest = null;
            let nearestDist = Infinity;

            this.places.forEach((place) => {
                if (!place.lat || !place.lng) return;
                const dist = haversineDistance(place.lat, place.lng, lat, lng);
                if (dist < nearestDist) {
                    nearestDist = dist;
                    nearest = place;
                }
            });

            const bounds = new google.maps.LatLngBounds();
            bounds.extend(location);

            if (nearest) {
                bounds.extend(new google.maps.LatLng(nearest.lat, nearest.lng));
            }

            this._map.fitBounds(bounds);
        },

        sortByDistance() {
            if (!this._map) return;

            const center = this._map.getCenter();
            const centerLat = center.lat();
            const centerLng = center.lng();

            this.sortedPlaces = [...this.places].sort((a, b) => {
                const distA = haversineDistance(a.lat, a.lng, centerLat, centerLng);
                const distB = haversineDistance(b.lat, b.lng, centerLat, centerLng);
                return distA - distB;
            });
        },
    };
}

export function placeDetail(config) {
    return {
        lat: config.lat,
        lng: config.lng,
        mapsKey: config.mapsKey || '',
        locale: config.locale || 'nl',

        init() {
            loadMapsApi(this.mapsKey, this.locale).then(() => this.renderMap());
        },

        renderMap() {
            initMarkerIcons();

            const latlng = new google.maps.LatLng(this.lat, this.lng);
            const map = new google.maps.Map(this.$refs.map, {
                zoom: 14,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles,
                scrollwheel: false,
                disableDefaultUI: true,
            });

            new google.maps.Marker({
                position: latlng,
                map: map,
                icon: markerIcon,
            });
        },
    };
}

export function trackAndTrace(config) {
    return {
        points: config.points || [],
        mapsKey: config.mapsKey || '',
        locale: config.locale || 'nl',

        init() {
            if (this.points.length === 0) return;
            loadMapsApi(this.mapsKey, this.locale).then(() => this.renderMap());
        },

        renderMap() {
            const mapElement = this.$refs.map;
            if (!mapElement) return;

            const iconStart = {
                url: '/images/google-maps-marker_start.png',
                scaledSize: new google.maps.Size(26, 32),
            };
            const iconStop = {
                url: '/images/google-maps-marker.png',
                scaledSize: new google.maps.Size(26, 32),
            };
            const iconCurrent = {
                url: '/images/google-maps-marker_current.png',
                scaledSize: new google.maps.Size(26, 32),
            };

            const firstPoint = this.points[0];
            const center = new google.maps.LatLng(firstPoint.latitude, firstPoint.longitude);

            const map = new google.maps.Map(mapElement, {
                zoom: 12,
                center: center,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: mapStyles,
                scrollwheel: false,
                streetViewControl: false,
                disableDefaultUI: false,
            });

            const bounds = new google.maps.LatLngBounds();
            const infowindow = new google.maps.InfoWindow();
            const markers = [];

            this.points.forEach((point, i) => {
                const position = new google.maps.LatLng(point.latitude, point.longitude);

                let icon = iconStop;
                if (point.activity === 'START') icon = iconStart;
                else if (point.activity === 'CURRENT') icon = iconCurrent;

                const marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: icon,
                    zIndex: i,
                });

                markers.push(marker);
                bounds.extend(position);

                marker.addListener('click', () => {
                    infowindow.setContent(point.time + '<br>' + point.address);
                    infowindow.open(map, marker);
                });
            });

            map.fitBounds(bounds);

            // Allow table rows to trigger marker clicks
            this._markers = markers;
            this._map = map;
            this._infowindow = infowindow;
        },

        selectMarker(index) {
            if (!this._markers || !this._markers[index]) return;
            const marker = this._markers[index];
            this._infowindow.setContent(this.points[index].time + '<br>' + this.points[index].address);
            this._infowindow.open(this._map, marker);
            this._map.panTo(marker.getPosition());

            if (this.$refs.map) {
                this.$refs.map.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
    };
}

function haversineDistance(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lng2 - lng1) * Math.PI / 180;
    const rLat1 = lat1 * Math.PI / 180;
    const rLat2 = lat2 * Math.PI / 180;

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(rLat1) * Math.cos(rLat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}
